
import ReactApexChart from 'react-apexcharts';

const ManagerBudgetChart = ({ getManagerDashboard }: any) => {
  // Extract data from the API response
  const assignBudget = getManagerDashboard?.result?.assignBudget || 0;
  const utilizedBudget = getManagerDashboard?.result?.utilizedBudget || 0;

  // Chart options
  const pieChartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: ['Assigned Budget', 'Utilized Budget'],
    colors: ['#0A47E6', '#00945F'],
    legend: {
      show: true,
      position: 'bottom',
      offsetX: 10,
      offsetY: 0,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0,
          },
        },
      },
    ],
    tooltip: {
      y: {
        formatter: function (value: any) {
          return `$${value.toLocaleString('en-US')}`;
        },
      },
    },
  };

  // Chart series data
  const pieChartSeries = [assignBudget, utilizedBudget];


  return (
    <div className='d-flex justify-content-center w-100'>
      {assignBudget === 0 && utilizedBudget === 0 ? (
        <p className='mt-15'>Chart does not have any values to display.</p>
      ) : (
        <div className='legend-center'>
          <ReactApexChart options={pieChartOptions} series={pieChartSeries} type="donut" height={300} />
        </div>
      )}
    </div>
  )
}

export default ManagerBudgetChart